/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Basic_SummaryInputs */

const ja_playdata_pricing_basic_summary = /** @type {(inputs: Playdata_Pricing_Basic_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開催日程が10日間未満のeスポーツ大会`)
};

const en_playdata_pricing_basic_summary = /** @type {(inputs: Playdata_Pricing_Basic_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For short esports events broadcasting for less than 10 days.`)
};

/**
* | output |
* | --- |
* | "For short esports events broadcasting for less than 10 days." |
*
* @param {Playdata_Pricing_Basic_SummaryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_basic_summary = /** @type {((inputs?: Playdata_Pricing_Basic_SummaryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Basic_SummaryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_basic_summary(inputs)
	return en_playdata_pricing_basic_summary(inputs)
});